export default __webpack_public_path__ + "static/media/stories-image-1.64dc966a.png";